module.exports = __webpack_public_path__ + "static/media/beaconTraining.7b8c28a6.jpg";